import { BaseModel } from '@fry/lib/store';
import { AsyncTaskWizardData, AsyncTaskWizardDoc, AsyncTaskWizardHelpers, AsyncTaskWizardSteps } from './async-task.interface';


export class AsyncTaskWizard extends BaseModel<AsyncTaskWizardDoc> {

  constructor(doc: AsyncTaskWizardDoc) {
    super(doc);
  }

  public get wizardData(): AsyncTaskWizardHelpers {
    const wz = this.doc.wizardData || { currentStep: AsyncTaskWizardSteps.STEP_2 };
    if (wz.currentStep === null || wz.currentStep === undefined) {
      wz.currentStep = AsyncTaskWizardSteps.STEP_2;
    }
    return wz
  }

  public set wizardData(data: AsyncTaskWizardHelpers) {
    this.doc.wizardData = data;
  }

  public get data(): AsyncTaskWizardData {
    const data = this.doc.data || { source: { ids: [] }, params: {} };
    return data;
  }

  public updateWizardData(update: Partial<AsyncTaskWizardHelpers>) {
    const data = this.wizardData;
    const updated: AsyncTaskWizardHelpers = {
        ...data,
        ...update
    }
    this.wizardData = updated;
  }

}
